import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  amount: 1,
  unit: 'seconds'
};

export default defaults;
